import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      align-items: center;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { darken } from "polished";
import { Theme } from "@silvertours/front-shared";
var Container = /*#__PURE__*/ styled("div", {
    target: "e7kvkwu0"
})("display:flex;gap:1rem;", function(param) {
    var alignCenter = param.alignCenter;
    return alignCenter && css(_templateObject());
});
var ImageWrapper = /*#__PURE__*/ styled("div", {
    target: "e7kvkwu1"
})("display:none;", Theme.mq("lg"), "{display:block;position:relative;max-width:300px;height:300px;flex:0 0 50%;}");
var Headline = /*#__PURE__*/ styled("div", {
    target: "e7kvkwu2"
})("margin:0 0 1rem;font-weight:bold;font-size:1rem;");
var LegalText = /*#__PURE__*/ styled("div", {
    target: "e7kvkwu3"
})("margin:1rem 0;color:", function(param) {
    var theme = param.theme;
    return theme.color.secondary100;
}, ";font-size:0.75rem;a{color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";text-decoration:underline;text-underline-offset:0.125rem;transition:text-underline-offset 0.2s linear;&:hover,&:focus{color:", function(param) {
    var theme = param.theme;
    return theme.color.primary100;
}, ";}&:focus-visible{outline:0.125rem dashed ", function(param) {
    var theme = param.theme;
    return theme.color.natural70;
}, ";outline-offset:0.25rem;}&:active{color:", function(param) {
    var theme = param.theme;
    return darken(0.08, theme === null || theme === void 0 ? void 0 : theme.color.primary);
}, ";text-underline-offset:0.25rem;}}");
var FormContainer = /*#__PURE__*/ styled("div", {
    target: "e7kvkwu4"
})("height:100%;display:flex;flex-direction:column;justify-content:space-between;");
export { Container, FormContainer, ImageWrapper, Headline, LegalText };
